export default (email: string | null | undefined) => {
  if (!email) {
    return '-';
  }
  if (email && email?.length > 29) {
    return `...${email?.substring(email?.length - 26, email?.length)}`;
  }
  return email;
};
